(function() {
    const debug = true;
    const onDocumentReady = function(callback) {
        if (document.readyState != 'loading') {
            if (typeof callback === 'function') callback();
        } else {
            document.addEventListener('DOMContentLoaded', () => {
                if (typeof callback === 'function') callback();
            });
        }
    };

    onDocumentReady(() => {
        const ghostLogoOrigin = document.querySelector('[data-ghost-logo-origin]');
        if(!ghostLogoOrigin) return; // Nothing to do here, bailing out!

        const ghostLogoClone = ghostLogoOrigin.cloneNode(true);
        ghostLogoClone.removeAttribute('data-ghost-logo-origin');
        ghostLogoClone.setAttribute('data-ghost-logo-clone', 'true');

        // Injecting the clone at the top of the body
        document.body.insertBefore(ghostLogoClone, document.body.firstChild);

        window.requestAnimationFrame(() => {
            ghostLogoClone.setAttribute('data-ghost-logo-clone', 'ready');
        });
    });
})();